import { SortingRequest, SortingRestRequest } from '@rp/shared/models';

const toRest = ({ sorting }: SortingRequest): SortingRestRequest => ({
  sorting,
});

export const SortingAdapter = {
  toRest,
};
